import { PlaItem, TextAdItem } from '../types';

/**
 * Full-text search on PLA items using a simple case-insensitive substring match.
 *
 * Matches against title, searchTerm, domain and price.
 *
 * @param items PLA items to search.
 * @param queryRaw User query string; trimmed and lowercased.
 * @returns Filtered PLA items matching the query; original list if query is empty.
 */

export function searchPla(items: PlaItem[], queryRaw: string): PlaItem[] {
    const q = queryRaw?.trim().toLowerCase();
    if (!q) return items;
    return items.filter((item) =>
        item.title.toLowerCase().includes(q) ||
        item.searchTerm.toLowerCase().includes(q) ||
        item.domain.toLowerCase().includes(q) ||
        item.price.toLowerCase().includes(q)
    );
}

/**
 * Full-text search on text ads using a simple case-insensitive substring match.
 *
 * Matches against title, description, searchTerm and domain.
 *
 * @param items Text ads to search.
 * @param queryRaw User query string; trimmed and lowercased.
 * @returns Filtered text ads matching the query; original list if query is empty.
 */
export function searchTextAds(items: TextAdItem[], queryRaw: string): TextAdItem[] {
    const q = queryRaw?.trim().toLowerCase();
    if (!q) return items;
    return items.filter((item) =>
        item.title.toLowerCase().includes(q) ||
        item.description.toLowerCase().includes(q) ||
        item.searchTerm.toLowerCase().includes(q) ||
        item.domain.toLowerCase().includes(q)
    );
}

// Right panel items are PLA-like (same fields used in search)
export const searchRightPanel = searchPla;


